export default "__VITE_ASSET__DoQbSxss__"